var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.094,
    height: 50.094,
    viewBox: "0 0 50.094 50.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2a9eda;}.b{fill:#204866;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1489 -243.953)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(1490 271)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1489 243.953)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.985,3.914H41.808V3.131a3.131,3.131,0,1,0-6.262,0v.783h-13.5V3.131a3.131,3.131,0,1,0-6.262,0v.783H11.606A4.114,4.114,0,0,0,7.5,8.023V27.078A11.936,11.936,0,1,0,22.824,43.05H45.985a4.114,4.114,0,0,0,4.109-4.109V8.023A4.114,4.114,0,0,0,45.985,3.914ZM37.5,3.131a1.174,1.174,0,1,1,2.348,0V6.653a1.174,1.174,0,1,1-2.348,0Zm-19.764,0a1.174,1.174,0,1,1,2.348,0V6.653a1.174,1.174,0,1,1-2.348,0ZM11.606,5.87h4.176v.783a3.131,3.131,0,1,0,6.262,0V5.87h13.5v.783a3.131,3.131,0,1,0,6.262,0V5.87h4.176a2.155,2.155,0,0,1,2.152,2.152v5.87H9.454V8.023A2.155,2.155,0,0,1,11.606,5.87Zm.33,42.267a9.98,9.98,0,1,1,9.98-9.98,9.991,9.991,0,0,1-9.98,9.98Zm34.048-7.044H23.507A11.939,11.939,0,0,0,9.454,26.482V15.85H48.137V38.94A2.155,2.155,0,0,1,45.985,41.093Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.131,
    cy: 3.131,
    r: 3.131,
    transform: "translate(36.427 18.785)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.131,
    cy: 3.131,
    r: 3.131,
    transform: "translate(25.665 18.785)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.131,
    cy: 3.131,
    r: 3.131,
    transform: "translate(14.902 18.785)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.131,
    cy: 3.131,
    r: 3.131,
    transform: "translate(36.427 29.548)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.131,
    cy: 3.131,
    r: 3.131,
    transform: "translate(25.665 29.548)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.341-8.841l-.4,1.4h-1.2A3.108,3.108,0,0,1,5.693-5.523a4.279,4.279,0,0,1-2.619.875L6.79-.1V0H4.716L.648-4.937.636-6.045H2.653q1.909,0,2.273-1.392H.494l.4-1.4H4.881a1.685,1.685,0,0,0-.744-.943,2.8,2.8,0,0,0-1.483-.341H.494l.415-1.511H8.347l-.4,1.415-1.79-.011a3.2,3.2,0,0,1,.574,1.392Z",
    transform: "translate(1497 289)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9c9436b4.svg";
export { ForwardRef as ReactComponent };